import React, { useState } from 'react';
import Routes from './routes';
import Header from './components/Header';
import './styles.css'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Link } from '@material-ui/core';

function App() {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="App">
      <Header />
      <Routes />

      <Dialog open={open} onClose={handleClose} aria-labelledby="important-alert-title">
        <DialogTitle id="important-alert-title">Aviso Importante: O Extrato Financeiro mudou de endereço!</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Informamos que esta página exclusiva do Extrato Financeiro foi descontinuada e não é mais suportada pela Safetec.
          </Typography>
          <Typography gutterBottom>
            Mas não se preocupe! Agora, você pode acessar todas as suas informações financeiras com mais segurança e praticidade diretamente no nosso <strong>Portal do Cliente</strong>.
          </Typography>
          <Typography>
            👉 <Link href="https://portal.safetec.com.br/" target="_blank" rel="noopener">Acesse agora: https://portal.safetec.com.br/</Link>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Fechar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default App;
